import { useRef } from "react";
import { Stack, Box, FormControl, OutlinedInput, IconButton, CircularProgress } from "@mui/material";
import { SendOutlined as SendOutlinedIcon } from "@mui/icons-material";
import { blueGrey, grey } from "@mui/material/colors";
import captions from "../../../config/captions.json";

const ChatInput = ({ question, setQuestion, onRequest, getCaptionsAnswer, onEnterPress }) => {
  const inputRef = useRef(null);

  return (
    <Stack alignItems="center" justifyContent="center" className="subcard inputWrapper">
      <Box width="100%" zIndex={4} textAlign="center">
        <FormControl fullWidth variant="outlined">
          <OutlinedInput
            inputRef={inputRef}
            className="customOutlinedInput"
            multiline
            maxRows={6}
            minRows={1}
            sx={{
              color: blueGrey[500],
              backgroundColor: grey[50],
              "& textarea": {
                "&::-webkit-scrollbar": { cursor: "default", width: "0.9rem" },
                "&::-webkit-scrollbar-thumb": { cursor: "default" },
              },
            }}
            endAdornment={
              onRequest ? (
                <CircularProgress size="1.5rem" />
              ) : (
                <IconButton disabled={!question} onClick={() => getCaptionsAnswer(question)}>
                  <SendOutlinedIcon />
                </IconButton>
              )
            }
            autoFocus
            disabled={onRequest}
            onKeyUp={onEnterPress}
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            placeholder="Ask something..."
          />
        </FormControl>
      </Box>
      <Box width="100%" zIndex={4}  component="span" className="ai-disclaimer">
        {captions.labels.AI_DISCLAMER}
      </Box>
    </Stack>
  );
};

export default ChatInput;
